import { render, staticRenderFns } from "./GameBoard.vue?vue&type=template&id=85cd3af8&scoped=true"
import script from "./GameBoard.vue?vue&type=script&lang=js"
export * from "./GameBoard.vue?vue&type=script&lang=js"
import style0 from "./GameBoard.vue?vue&type=style&index=0&id=85cd3af8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85cd3af8",
  null
  
)

export default component.exports